import styled from 'styled-components';
import { Avatar, Typography } from 'antd';

const { Text } = Typography;

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  padding: 10px 20px;
  height: 100%;
`;

export const TitleImage = styled(Text)`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: #707070;
`;

export const ContainerImage = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 55%;
  margin-bottom: 21px;
`;

export const ContainerMiniatures = styled.div`
  display: flex;
  width: 80%;
`;

export const CarouselImages = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  overflow-x: hidden;
  height: 100%;
`;

export const ImageMiniature = styled(Avatar)`
  border-radius: 8px;
  width: 42px;
  height: 42px;
`;

export const ButtomActionGo = styled.div`
  position: absolute;
  display: flex;
  padding: 8px;
  color: #ffffff;
  cursor: pointer;
  left: ${props => props.left && 0};
  right: ${props => props.right && 0};
  z-index: 999;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: #001f2a;
`;

export const ImageFloating = styled.div`
  position: fixed;
  width: auto;
  height: auto;
  border: solid red 3px;
  z-index: 999;
  top: 2%;
  left: 2%;
`;
